import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category, MessageTemplate } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import {
  List,
  TextField,
  IconButton,
  ListItem,
  ListItemText,
  Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import CancelIcon from "@material-ui/icons/Cancel";

import CreateMessageTemplateDialog from "./createMessageTemplate";
import ApproveDialog from "./approveDialog";
import { DubitoSvc } from "src/api";
interface Props {
  open: boolean;
  templates: MessageTemplate[];
  onClose: () => void;
  onSelect: (text: string) => void;
  fetchMessageTemplates: () => void;
}

class MessageTemplatePicker extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    query: "",
    showNewCase: false,
    deleteMode: false,
    deleteOpen: false,
    itemToDelete: undefined
  };
  componentWillReceiveProps(next: Props) {
    if (!this.props.open && next.open) {
      this.setState({ open: next.open });
    }
  }
  componentWillMount() {
    if (!this.props.templates) {
      this.props.fetchMessageTemplates();
    }
  }
  handleClose = () => {
    this.setState({ open: false, query: "", deleteMode: false });
    this.props.onClose();
  };
  deleteItem = () => {
    DubitoSvc.deleteMessageTemplate({
      template_id: this.state.itemToDelete.id
    }).then(res => {
      this.setState({
        deleteOpen: false,
        itemToDelete: undefined
      });
      this.props.fetchMessageTemplates();
    });
  };
  render() {
    return (
      <div>
        {this.state.showNewCase && (
          <CreateMessageTemplateDialog
            open={this.state.showNewCase}
            onCreate={caseID => {
              this.props.onSelect(caseID);
              this.setState({ showNewCase: false, open: false });
              this.props.fetchMessageTemplates();
            }}
            onClose={() => this.setState({ showNewCase: false })}
          />
        )}
        {this.state.deleteMode && this.state.deleteOpen && (
          <ApproveDialog
            title={"Confirm Delete"}
            description={
              "Do you really want to delete this: '" +
              this.state.itemToDelete.text +
              "' ?"
            }
            open={this.state.deleteOpen}
            onApprove={this.deleteItem}
          />
        )}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { height: "100%" }
          }}
          style={{ height: "100%" }}
        >
          {this.state.deleteMode ? (
            <DialogTitle id="scroll-dialog-title">
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ flex: 1, color: "red" }}>
                  Select a Template to delete
                </span>

                <IconButton
                  onClick={() => this.setState({ deleteMode: false })}
                >
                  <CancelIcon />
                </IconButton>
              </div>
            </DialogTitle>
          ) : (
            <DialogTitle id="scroll-dialog-title">
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ flex: 1 }}>Select a Template</span>
                <IconButton onClick={() => this.setState({ deleteMode: true })}>
                  <DeleteIcon />
                </IconButton>
                <IconButton
                  onClick={() => this.setState({ showNewCase: true })}
                >
                  <AddIcon />
                </IconButton>
              </div>
            </DialogTitle>
          )}
          <DialogContent>
            <TextField
              placeholder="Search"
              autoFocus
              onChange={e =>
                this.setState({ query: e.target.value.toLocaleLowerCase() })
              }
              style={{ width: "100%" }}
              fullWidth
            />
            <List
              style={{
                flex: 1,
                width: "100%",
                height: "100%"
              }}
            >
              {!this.props.templates
                ? "Loading"
                : this.props.templates.map(c => {
                    if (c.text.toLowerCase().indexOf(this.state.query) > -1) {
                      return (
                        <ListItem
                          button
                          key={c.id}
                          onClick={() => {
                            if (!this.state.deleteMode) {
                              this.props.onSelect(c.text);
                              this.setState({ open: false, query: "" });
                            } else {
                              this.setState({
                                itemToDelete: c,
                                deleteOpen: true,
                                query: ""
                              });
                            }
                          }}
                        >
                          <Typography style={{ fontSize: 14 }}>
                            {c.text}
                          </Typography>
                        </ListItem>
                      );
                    }
                  })}
            </List>
            <div
              style={{
                marginLeft: 0,
                marginRight: 0,
                marginBottom: 0,
                flex: 1
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    templates: state.cases.messageTemplates
  }),
  dispatch => ({
    fetchMessageTemplates: (): any => dispatch(actions.fetchMessageTemplates())
  })
)(MessageTemplatePicker);



// WEBPACK FOOTER //
// ./src/components/dialogs/messageTemplatePicker.tsx